<template>
  <div class="add-work-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>新增工作</span>
      </div>

      <el-form
        ref="form"
        :model="addWorkInfo"
        label-width="120px"
        label-position="right"
        class="text-left"
      >
        <!-- 工作名称 & 工作类型（修复级联选择器数据显示问题） -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="工作名称"
              prop="workName"
              :rules="[
                { required: true, message: '请输入工作名称', trigger: 'blur' },
              ]"
            >
              <el-input
                v-model.trim="addWorkInfo.workName"
                placeholder="请输入工作名称"
                maxlength="20"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="工作类型"
              prop="wtIds"
              :rules="[
                {
                  required: true,
                  message: '请选择工作类型',
                  trigger: 'change',
                },
              ]"
            >
              <!-- 修复级联选择器配置 -->
              <el-cascader
                v-model="addWorkInfo.wtIds"
                :options="workTypeOptions"
                :props="cascaderProps"
                placeholder="请选择工作类型"
                style="width: 100%"
                clearable
                @change="handleCascaderChange"
                :show-all-levels="true"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 处理人 & 抄送人 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="处理人">
              <div class="staff-tags">
                <el-tag
                  v-for="(staff, index) in addWorkInfo.staffs"
                  :key="`processor-${staff.staffId}-${staff.communityId}-${index}`"
                  closable
                  @close="_deleteWorkStaff(staff)"
                >
                  {{ staff.staffName }}
                  <span style="font-size: 12px; color: #999; margin-left: 5px">
                    ({{ staff.communityName || staff.communityId }})
                  </span>
                </el-tag>
                <el-button type="text" @click="openParkSelect('processor')">
                  <i class="el-icon-search"></i>选择
                </el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抄送人">
              <div class="staff-tags">
                <el-tag
                  v-for="(staff, index) in addWorkInfo.copyStaffs"
                  :key="`cc-${staff.staffId}-${staff.communityId}-${index}`"
                  closable
                  @close="_deleteCopyWorkStaff(staff)"
                >
                  {{ staff.staffName }}
                  <span style="font-size: 12px; color: #999; margin-left: 5px">
                    ({{ staff.communityName || staff.communityId }})
                  </span>
                </el-tag>
                <el-button type="text" @click="openParkSelect('cc')">
                  <i class="el-icon-search"></i>选择
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 工作周期 & 附件 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="工作周期"
              prop="workCycle"
              :rules="[
                {
                  required: true,
                  message: '请选择工作周期',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="addWorkInfo.workCycle"
                placeholder="请选择工作周期"
                style="width: 100%"
                @change="handleWorkCycleChange"
              >
                <el-option label="一次性工单" value="1001" />
                <el-option label="周期性工单" value="2002" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="紧急程度"
              prop="urgencyLevel"
              :rules="[
                {
                  required: true,
                  message: '请选择紧急程度',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="addWorkInfo.urgencyLevel"
                placeholder="请选择紧急程度"
                style="width: 100%"
                @change="handleWorkCycleChange"
              >
                <el-option label="重点" value="1001" />
                <el-option label="紧急" value="1002" />
                <el-option label="普通" value="1003" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="附件">
              <upload-file ref="uploadFile" @notify="handleFileUpload" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 多组时间/内容项 -->
        <el-row
          v-for="(item, index) in addWorkInfo.contents"
          :key="item.id"
          class="work-content-group"
        >
          <el-row :gutter="20" class="content-operate-row">
            <el-col :span="8">
              <el-form-item
                :label="`时间${index + 1}`"
                :prop="`contents[${index}].periodTime`"
                :rules="[
                  {
                    required: true,
                    message: `请选择第${index + 1}条内容对应日期`,
                    trigger: 'change',
                  },
                ]"
              >
                <el-date-picker
                  v-model="item.periodTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="`请选择第${index + 1}个内容对应日期`"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="`内容${index + 1}`"
                :prop="`contents[${index}].content`"
                :rules="[
                  {
                    required: true,
                    message: `请填写第${index + 1}条内容的详情`,
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="item.content"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入工作内容详情"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4" class="text-center pt20">
              <el-button
                type="text"
                @click="addWorkContent"
                v-if="index === 0 && addWorkInfo.workCycle === '2002'"
              >
                添加内容
              </el-button>
              <el-button
                type="danger"
                @click="deleteWorkContent(item)"
                v-else-if="addWorkInfo.workCycle === '2002'"
              >
                删除内容
              </el-button>
            </el-col>
          </el-row>
        </el-row>

        <!-- 按钮布局 -->
        <el-row>
          <el-col :span="24" class="text-right">
            <el-button type="warning" @click="goBack">
              <i class="el-icon-arrow-left"></i>返回
            </el-button>
            <el-button
              type="info"
              @click="saveDraft"
              :loading="submitLoading"
              style="margin-left: 10px"
            >
              <i class="el-icon-save"></i>保存草稿
            </el-button>
            <el-button
              type="primary"
              @click="submitForm"
              :loading="submitLoading"
              style="margin-left: 10px"
            >
              <i class="el-icon-check"></i>提交
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 园区选择弹窗 -->
    <el-dialog
      title="选择园区"
      :visible.sync="parkDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      class="park-select-dialog"
      @close="resetParkState"
    >
      <el-input
        v-model="parkSearchName"
        placeholder="输入园区名称搜索"
        prefix-icon="el-icon-search"
        style="margin-bottom: 15px"
        @input="handleParkSearch"
        clearable
      />
      <el-table
        v-loading="parkLoading"
        :data="filteredParkList"
        border
        style="width: 100%"
        @row-click="handleParkSelect"
        size="small"
        highlight-current-row
      >
        <el-table-column
          prop="name"
          label="园区名称"
          align="center"
          min-width="200"
        />
        <el-table-column label="园区编码" align="center" min-width="150">
          <template slot-scope="scope">
            {{ getCommunityCode(scope.row) || "无" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="storeName"
          label="所属物业"
          align="center"
          min-width="150"
        />
      </el-table>
      <el-pagination
        @size-change="handleParkSizeChange"
        @current-change="handleParkPageChange"
        :current-page="parkPage.current"
        :page-sizes="[5, 10, 20]"
        :page-size="parkPage.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="parkPage.total"
        style="margin-top: 15px; text-align: right"
        background
      />
    </el-dialog>

    <!-- 人员选择组件 -->
    <select-staff
      ref="selectStaff"
      @selectStaff="selectStaff"
      :community-id="selectedCommunityId"
      :key="`staff-select-${selectedCommunityId}-${currentSelectType}`"
    />
  </div>
</template>

<script>
import { saveWorkPool, listWorkType } from "@/api/oa/addWorkApi";
import { getCommunityId, listCommunitys } from "@/api/community/communityApi";
import SelectStaff from "@/components/staff/SelectStaff";
import UploadFile from "@/components/upload/uploadFile";
import { getUuid } from "@/utils/commonUtil";

export default {
  name: "AddWorkList",
  components: { SelectStaff, UploadFile },
  data() {
    return {
      chooseStaffFlag: "1",
      submitLoading: false,
      // 园区相关
      parkDialogVisible: false,
      parkLoading: false,
      parkSearchName: "",
      parkList: [],
      parkPage: { current: 1, size: 10, total: 0 },
      selectedCommunityId: "",
      selectedCommunityName: "",
      currentSelectType: "",
      // 修复级联选择器配置（核心修改）
      cascaderProps: {
        value: "wtId",
        label: "typeName",
        children: "children",
        checkStrictly: true, // 改为true：允许选择父节点，且子节点能正常渲染
        expandTrigger: "click",
        lazy: false, // 关闭懒加载，使用本地数据
        emitPath: true, // 确保返回完整的路径数组
      },
      workTypeOptions: [],
      // 表单核心数据
      addWorkInfo: {
        workName: "",
        wtIds: [],
        wtId: "",
        workCycle: "1001",
        urgencyLevel: "",
        staffs: [],
        copyStaffs: [],
        pathUrl: "",
        contents: [],
        period: "",
        months: [],
        days: [],
        workdays: [],
        hours: "24",
        communityId: "",
        problemsEncountered: "",
        workPlan: "",
      },
      weekDays: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
    };
  },
  computed: {
    filteredParkList() {
      if (!this.parkSearchName) return this.parkList;
      return this.parkList.filter((item) =>
        item.name.toLowerCase().includes(this.parkSearchName.toLowerCase()),
      );
    },
  },
  created() {
    this.addWorkInfo.communityId = getCommunityId();
    this._listWorkTypes();
    this.addWorkContent();
  },
  methods: {
    resetParkState() {
      this.selectedCommunityId = "";
      this.selectedCommunityName = "";
      this.parkSearchName = "";
      this.parkPage.current = 1;
    },

    getCommunityCode(row) {
      if (!row.communityAttrDtos || !Array.isArray(row.communityAttrDtos)) {
        return "";
      }
      const codeItem = row.communityAttrDtos.find(
        (item) => item.specName === "社区编码",
      );
      return codeItem.value || "";
    },

    openParkSelect(type) {
      this.resetParkState();
      this.currentSelectType = type;
      this.chooseStaffFlag = type === "processor" ? "1" : "2";
      this.getParkList();
      this.parkDialogVisible = true;
    },

    async getParkList() {
      this.parkLoading = true;
      try {
        const params = { page: this.parkPage.current, row: this.parkPage.size };
        const res = await listCommunitys(params);
        this.parkList = res.data || [];
        this.parkPage.total = res.total || 0;
      } catch (error) {
        console.error("获取园区列表失败:", error);
        this.$message.warning("获取园区列表失败");
      } finally {
        this.parkLoading = false;
      }
    },

    handleParkSearch() {
      this.parkPage.current = 1;
      this.getParkList();
    },

    handleParkSizeChange(size) {
      this.parkPage.size = size;
      this.getParkList();
    },

    handleParkPageChange(current) {
      this.parkPage.current = current;
      this.getParkList();
    },

    handleParkSelect(row) {
      let communityId = row.communityId;
      if (!communityId) {
        const idItem = row.communityAttrDtos.find(
          (item) => item.specName === "社区编码",
        );
        if (idItem) communityId = idItem.value;
      }
      if (!communityId) {
        this.$message.error("未找到有效的园区 ID，请联系管理员");
        return;
      }

      this.selectedCommunityId = communityId;
      this.selectedCommunityName = row.name;
      this.parkDialogVisible = false;

      this.$nextTick(() => {
        if (this.$refs.selectStaff) {
          this.$refs.selectStaff.open(communityId);
        }
      });
    },

    addWorkValidate(isDraft = false) {
      return new Promise((resolve, reject) => {
        if (!this.$refs.form) return reject(new Error("表单实例不存在"));

        if (isDraft) {
          let draftValid = true;
          if (!this.addWorkInfo.workName.trim()) {
            this.$message.warning("请输入工作名称");
            draftValid = false;
          }
          if (!this.addWorkInfo.wtIds.length) {
            this.$message.warning("请选择工作类型");
            draftValid = false;
          }
          resolve(draftValid);
          return;
        }

        this.$refs.form.validate((valid) => {
          if (!valid) return resolve(false);

          let contentValid = true;
          this.addWorkInfo.contents.forEach((item, index) => {
            if (!item.content.trim()) {
              this.$message.warning(`请填写第${index + 1}条内容的详情`);
              contentValid = false;
            }
            if (!item.periodTime) {
              this.$message.warning(`请选择第${index + 1}条内容的对应时间`);
              contentValid = false;
            }
          });
          resolve(contentValid);
        });
      });
    },

    async handleWorkSubmit(isDraft = false) {
      if (this.submitLoading) return;
      this.submitLoading = true;

      try {
        const valid = await this.addWorkValidate(isDraft);
        if (!valid) return;

        const params = {
          ...this.addWorkInfo,
          wtId: this.addWorkInfo.wtIds[this.addWorkInfo.wtIds.length - 1] || "",
          isDraft: isDraft ? 1 : 0,
          contents: this.addWorkInfo.contents.map((item) => ({
            ...item,
            wtId:
              this.addWorkInfo.wtIds[this.addWorkInfo.wtIds.length - 1] || "",
          })),
        };

        console.log("🚀 最终提交参数:", params);
        const res = await saveWorkPool(params);

        const successMsg = isDraft ? "草稿保存成功" : "提交成功";
        const failMsg = isDraft ? "草稿保存失败" : "提交失败";

        if (res.code === 0) {
          this.$message.success(successMsg);
          if (!isDraft) this.$router.go(-1);
        } else {
          this.$message.error(res.msg || failMsg);
        }
      } catch (error) {
        console.error(isDraft ? "保存草稿失败:" : "提交工单失败:", error);
        this.$message.error(isDraft ? "草稿保存异常" : "提交异常");
      } finally {
        this.submitLoading = false;
      }
    },

    async submitForm() {
      await this.handleWorkSubmit(false);
    },

    async saveDraft() {
      await this.handleWorkSubmit(true);
    },

    // 修复：直接使用接口返回的树形数据，无需转换
    async _listWorkTypes() {
      try {
        const res = await listWorkType({
          page: 1,
          row: 100,
          communityId: this.addWorkInfo.communityId,
        });
        // 核心修复：直接赋值接口返回的树形数据
        this.workTypeOptions = res.data || [];
        console.log("📋 工作类型树形数据:", this.workTypeOptions);
      } catch (error) {
        console.error("获取工作类型失败:", error);
        this.$message.warning("获取工作类型失败");
      }
    },

    // 修复级联选择变更逻辑
    handleCascaderChange(val) {
      console.log("🚀 级联选择结果:", val);
      this.addWorkInfo.wtIds = val;
      // 取最后一个ID作为提交的wtId
      this.addWorkInfo.wtId = val.length > 0 ? val[val.length - 1] : "";
    },

    selectStaff(staff) {
      if (!staff) {
        this.$message.warning("人员数据异常，请重新选择");
        this.resetParkState();
        return;
      }

      const targetList =
        this.chooseStaffFlag === "1"
          ? this.addWorkInfo.staffs
          : this.addWorkInfo.copyStaffs;
      const staffId = staff.id || staff.userId;
      const isExist = targetList.some(
        (item) =>
          item.staffId === staffId &&
          item.communityId === this.selectedCommunityId,
      );

      if (!isExist) {
        targetList.push({
          staffId,
          staffName: staff.name || staff.userName,
          communityId: this.selectedCommunityId,
          communityName: this.selectedCommunityName,
        });
      }

      this.resetParkState();
    },

    handleFileUpload(data) {
      console.log("🔧 接收上传组件数据:", data);
      this.addWorkInfo.pathUrl = data.realFileName || "";
      console.log("🔧 pathUrl 字符串格式:", this.addWorkInfo.pathUrl);
    },

    _deleteWorkStaff(staff) {
      if (!staff) return;
      this.addWorkInfo.staffs = this.addWorkInfo.staffs.filter(
        (item) =>
          !(
            item.staffId === staff.staffId &&
            item.communityId === staff.communityId
          ),
      );
    },

    _deleteCopyWorkStaff(staff) {
      if (!staff) return;
      this.addWorkInfo.copyStaffs = this.addWorkInfo.copyStaffs.filter(
        (item) =>
          !(
            item.staffId === staff.staffId &&
            item.communityId === staff.communityId
          ),
      );
    },

    addWorkContent() {
      this.addWorkInfo.contents.push({
        id: getUuid(),
        periodTime: "",
        content: "",
      });
    },

    deleteWorkContent(item) {
      if (this.addWorkInfo.contents.length <= 1) {
        this.$message.warning("至少保留1条工作内容");
        return;
      }
      this.addWorkInfo.contents = this.addWorkInfo.contents.filter(
        (row) => row.id !== item.id,
      );
    },

    handleWorkCycleChange(val) {
      if (val === "1001" && this.addWorkInfo.contents.length > 1) {
        this.addWorkInfo.contents = this.addWorkInfo.contents.slice(0, 1);
      }
      this.addWorkInfo.period = "";
      this.addWorkInfo.months = [];
      this.addWorkInfo.days = [];
      this.addWorkInfo.workdays = [];
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.add-work-container {
  padding: 20px;
}

.staff-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 36px;
}

.staff-tags .el-tag {
  margin-right: 10px;
  margin-bottom: 5px;
}

.flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.text-right {
  text-align: right;
}

.work-content-group {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f5f5f5;
}

.pt20 {
  padding-top: 20px;
}

.content-operate-row {
  margin-bottom: 10px;
}

.park-select-dialog .el-dialog__body {
  padding: 15px 20px;
}
.park-select-dialog .el-table {
  --el-table-row-hover-bg-color: #f8fafc;
  --el-table-current-row-bg-color: #e6f7ff;
}
.park-select-dialog .el-pagination {
  --el-pagination-button-active-bg-color: #409eff;
  margin-top: 15px;
  text-align: right;
}

/* 优化级联选择器样式 */
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-cascader-node__label {
  padding: 4px 8px;
}
::v-deep .el-cascader-menu {
  max-height: 300px; /* 增大菜单高度，显示更多节点 */
  min-width: 200px; /* 增大菜单宽度，避免文字截断 */
}
/* 修复子节点显示问题 */
::v-deep .el-cascader-menu__wrap {
  overflow-y: auto !important;
}
::v-deep .el-cascader-node {
  height: auto !important;
  line-height: 24px !important;
  padding: 2px 0 !important;
}
</style>
